import axios from 'axios';
import { getAccessToken } from '../Authentication/AuthenticationService';
import AppConstants from '../AppConstants';

const baseUrl = AppConstants.G2W_BROKER_BASE_URL;

export function getMetadata() {
  return axios.get(baseUrl + '/api/organizers/me/metadata', {
    params: {
      client: AppConstants.APP_NAME
    },
    headers: {
      Authorization: 'Token ' + getAccessToken()
    }
  });
}

export function getUserSettings(accountKey, userKey) {
  return axios.get(`${baseUrl}/api/accounts/${accountKey}/users/${userKey}/settings`, {
    params: {
      client: AppConstants.APP_NAME,
      attributes: 'all',
      includeEntitlements: true
    },
    headers: {
      Authorization: 'Token ' + getAccessToken()
    }
  });
}

export function updateUserSettings(accountKey, userKey, flags = {}) {
  return axios.put(
    `${baseUrl}/api/accounts/${accountKey}/users/${userKey}/settings?client=${AppConstants.APP_NAME}`,
    flags,
    {
      headers: {
        Authorization: 'Token ' + getAccessToken()
      }
    }
  );
}

export function adminCheck(accountKey) {
  return axios.get(`${baseUrl}/api/accounts/${accountKey}/isAdmin`, {
    headers: {
      Authorization: 'Token ' + getAccessToken()
    }
  });
}



// WEBPACK FOOTER //
// ./src/Apis/G2WBrokerApi.js